import React from 'react';
import cn from 'classnames';

export interface TableCellBaseProps {
    secondary?: boolean;
    header?: boolean;
}

type TableCellDataProps = TableCellBaseProps &
    React.TdHTMLAttributes<HTMLTableCellElement>;

type TableCellHeadProps = TableCellBaseProps &
    React.ThHTMLAttributes<HTMLTableCellElement>;

type TableCellProps = TableCellDataProps | TableCellHeadProps;

/**
 * @name    m-table-cell
 * @componentType    atom
 *
 * @param   {boolean}     secondary            Modifier to set the content bold
 * @param   {boolean}     header          Type of the cell (header or body)
 * @param   {ReactNode}   children        Content of the table cell
 *
 * @description
 * This is a single cell of a table
 */
const TableCell = React.forwardRef<HTMLTableCellElement, TableCellProps>(
    (
        { secondary = false, header = false, children, className, ...rest },
        ref,
    ) => {
        const tableCellClass = cn({
            '-secondary': secondary,
            [className]: className,
        });

        return header ? (
            <th ref={ref} className={tableCellClass} align={'left'} {...rest}>
                {children}
            </th>
        ) : (
            <td ref={ref} className={tableCellClass} {...rest}>
                {children}
            </td>
        );
    },
);

TableCell.displayName = 'TableCell';

export { TableCell, TableCellProps };
